import React, { useState, useContext, useEffect } from "react";
import AuthContext from "../../Context/AuthContext";
import { Link, useNavigate, useParams } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import Dropdown from "react-bootstrap/Dropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList, faLanguage } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { useTranslation } from "react-i18next";
import "./EditValueForm.css";

function EditValueForm() {
  const [title, setTitle] = useState("");
  const [titleEnglish, setTitleEnglish] = useState("");
  const [description, setDescription] = useState("");
  const [descriptionEnglish, setDescriptionEnglish] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const [english, setEnglish] = useState(false);

  const navigate = useNavigate();

  const { state } = useContext(AuthContext);

  let { vid } = useParams();

  const { t } = useTranslation();

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/values/${vid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setTitle(response.data.value.title);
      setTitleEnglish(response.data.value.titleEnglish);
      setDescription(response.data.value.description);
      setDescriptionEnglish(response.data.value.descriptionEnglish);

      if (state.language === "en") {
        setEnglish(true);
      } else {
        setEnglish(false);
      }

      setIsLoading(false);
    }
    fetch();
  }, [state.token, vid, state.language]);

  const activateEnglish = () => {
    setEnglish(true);
  };

  const handleSubmit = async () => {
    try {
      await axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND_URL}/values/${vid}`,
        data: {
          title: title,
          titleEnglish: titleEnglish,
          description: description,
          descriptionEnglish: descriptionEnglish,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      navigate("/values");
    } catch (error) {
      console.log(error.response.data);
    }
  };

  const handleTitleChange = (evt) => {
    setTitle(evt.target.value);
  };

  const handleDescriptionChange = (evt) => {
    setDescription(evt.target.value);
  };

  const handleTitleEnglishChange = (evt) => {
    setTitleEnglish(evt.target.value);
  };

  const handleDescriptionEnglishChange = (evt) => {
    setDescriptionEnglish(evt.target.value);
  };

  if (isLoading === true) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Container fluid>
        <Row>
          <Col lg={11} className="new-account-header">
            <h2>{t("Reconocimientos.Valores.Valor.EditForm.Titulo")}</h2>
          </Col>
          <Col lg={1} className="new-scale-header mb-2">
            <Dropdown>
              <Dropdown.Toggle id="dropdown-basic">
                <FontAwesomeIcon icon={faList} />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={activateEnglish}>
                  <FontAwesomeIcon icon={faLanguage} /> English
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Col>
        </Row>
        <Row>
          <Col className="new-account-form">
            <Form>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Título</Form.Label>
                <Form.Control
                  type="text"
                  onChange={handleTitleChange}
                  value={title}
                />
              </Form.Group>
              {english ? (
                <Form.Group className="mb-3">
                  <Form.Label>Title</Form.Label>
                  <Form.Control
                    type="text"
                    onChange={handleTitleEnglishChange}
                    value={titleEnglish}
                  />
                </Form.Group>
              ) : (
                <></>
              )}
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Descripción</Form.Label>
                <Form.Control
                  type="text"
                  onChange={handleDescriptionChange}
                  value={description}
                />
              </Form.Group>
              {english ? (
                <Form.Group className="mb-3">
                  <Form.Label>Description</Form.Label>
                  <Form.Control
                    type="text"
                    onChange={handleDescriptionEnglishChange}
                    value={descriptionEnglish}
                  />
                </Form.Group>
              ) : (
                <></>
              )}
              <Button className="primary" onClick={handleSubmit}>
                {t("Reconocimientos.Valores.Valor.EditForm.Guardar")}
              </Button>
              <Link to="/values">
                <Button className="danger">
                  {t("Reconocimientos.Valores.Valor.EditForm.Cancelar")}
                </Button>
              </Link>
            </Form>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default EditValueForm;
